import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { getSlicedList } from './helpers';
import { VpMediaIcon } from '../../components';

const boxStyles = {
  color: 'vpColors.blueMain',
  backgroundColor: 'vpColors.blueLighter',
  p: '7px 10px',
  borderRadius: '4px'
};

const VpMediaIconList = ({ videos, attachments }) => {
  const mediaList = useMemo(
    () => getSlicedList([...videos, ...attachments], 3),
    [videos, attachments]
  );

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {mediaList?.map((media) =>
        media?.id === 'extra-count' ? (
          <Box key={media?.id} sx={boxStyles}>
            {media?.name}
          </Box>
        ) : (
          <VpMediaIcon key={media?.mediaId || media?.attachmentId} media={media} />
        )
      )}
    </Stack>
  );
};

VpMediaIconList.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object),
  attachments: PropTypes.arrayOf(PropTypes.object)
};

export default VpMediaIconList;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaIconList.jsx